function deepFreeze(obj) {
  var propNames = Object.getOwnPropertyNames(obj)
  propNames.forEach(function(name) {
    var prop = obj[name]
    if (typeof prop == 'object' && prop !== null) {
      deepFreeze(prop)
    }
  })
  return Object.freeze(obj)
}

const isProd = process.env.NODE_ENV === 'production'
const useLocalApi = process.env.VUE_APP_APIHOST && process.env.VUE_APP_APIHOST === 'local'

const CONFIG = {
  API_HOST: useLocalApi
    ? 'http://localhost:8600'
    : isProd
    ? 'https://uni-api.unicapsule.com'
    : 'https://uni-api.unicapsule.com',
  GOOGLE_MAP_KEY: isProd ? 'AIzaSyC4nF5Ftx27x5EoY1j9OSt0UwyOetOiVTY' : 'AIzaSyA2EHo3V9NcOnw0GcSEoAt9l-EEkEo5sck',
  DEFAULT_MAP_ZOOM: 5,
  LOCALE_KEY_LANG: 'localeLanguage',
  DEFAULT_LANG: 'en', // en, zh
  API_LANGS: {
    // 接口返回的中英文对应key值
    en: 'en-US',
    zh: 'zh-CN',
  },
  privateLink: {
    router: {
      rental: 'r',
      sell: 'q',
    },
  },
  PRICE_RANGE_RATE: 50, // 1~100 对应 50~5000
  FILTER_ITEMS: [
    // 筛选栏各项配置
    {
      name: 'city',
      type: {
        rental: 'RENTAL_CITY',
        sell: 'SELL_CITY',
      },
      default: ['-1'],
      isRemoteOptions: true,
      allowCancel: false,
      any: { id: '-1', name: { 'en-US': 'Any', 'zh-CN': '任意' } },
    },
    {
      name: 'district',
      default: ['-1'],
      type: {
        rental: 'RENTAL_DISTRICT',
        sell: 'SELL_DISTRICT',
      },
      isRemoteOptions: 1,
      allowCancel: true,
      multiple: true,
      any: { id: '-1', name: { 'en-US': 'Any', 'zh-CN': '任意' } },
    },
    {
      name: 'school',
      default: ['-1'],
      isRemoteOptions: 1,
      type: {
        sell: 'RENTAL_SCHOOL',
        rental: 'SELL_SCHOOL',
      },
      allowCancel: true,
      multiple: true,
      any: { id: '-1', name: { 'en-US': 'Any', 'zh-CN': '任意' } },
    },
    {
      name: 'propertyType',
      default: ['-1'],
      allowCancel: true,
      multiple: true,
      any: { id: '-1', name: { 'en-US': 'Any', 'zh-CN': '任意' } },
    },
    {
      name: 'placeType',
      default: ['-1'],
      allowCancel: true,
      any: { id: '-1', name: { 'en-US': 'Any', 'zh-CN': '不限类型' } },
    },
    {
      name: 'houseType',
      default: ['-1'],
      type: {
        sell: 'SELL_HOUSE_TYPE',
        rental: 'RENTAL_HOUSE_TYPE',
      },
      allowCancel: true,
      isRemoteOptions: true,
      multiple: true,
      any: { id: '-1', name: { 'en-US': 'Any', 'zh-CN': '不限类型' } },
      addon: [
        // { id: 'studio', name: { 'en-US': 'Studio', 'zh-CN': 'Studio' } },
        // { id: 'low', name: { 'en-US': 'Low', 'zh-CN': '低楼层' } },
        // { id: 'mid', name: { 'en-US': 'Middle', 'zh-CN': '中楼层' } },
        // { id: 'high', name: { 'en-US': 'High', 'zh-CN': '高楼层' } },
      ],
    },
    {
      name: 'elevator',
      default: ['-1'],
      allowCancel: false,
      any: { id: '-1', name: { 'en-US': 'Any', 'zh-CN': '不限' } },
    },
    // {
    //   name: 'floor',
    //   default: ['-1'],
    //   allowCancel: false,
    //   any: { id: '-1', name: { 'en-US': 'Any', 'zh-CN': '不限' } },
    // },
    {
      name: 'inside',
      default: [],
      multiple: true,
      allowCancel: true,
      isRemoteOptions: true,
    },
    {
      name: 'building',
      default: [],
      allowCancel: true,
      multiple: true,
      isRemoteOptions: true,
    },
    {
      name: 'orientation',
      default: [],
      allowCancel: true,
    },
    { name: 'decoration', default: [], allowCancel: true },
    {
      name: 'payPeriod',
      default: ['-1'],
      allowCancel: false,
      any: { id: '-1', name: { 'en-US': 'Any', 'zh-CN': '不限' } },
    },
    { name: 'other', default: [], allowCancel: true, multiple: true },
  ],
  DEFAULT_SELECTS: {
    // 每个筛选栏的选项
    propertyType: [
      { id: 'flat', name: { 'en-US': 'Flat', 'zh-CN': 'Flat' }, type: 'rental' },
      { id: 'condo', name: { 'en-US': 'Condo', 'zh-CN': 'Condo' }, type: 'common' },
      { id: 'apartment', name: { 'en-US': 'Apartment', 'zh-CN': 'Apartment' }, type: 'common' },
      { id: 'home', name: { 'en-US': 'Home', 'zh-CN': 'Home' }, type: 'common' },
      { id: 'townhome', name: { 'en-US': 'Town House', 'zh-CN': 'Town House' }, type: 'common' },
      { id: 'multiunits', name: { 'en-US': 'Multi-Units', 'zh-CN': 'Multi-Units' }, type: 'sell' },
    ],
    placeType: [
      { id: 'entire', name: { 'en-US': 'Entire House', 'zh-CN': '整套出租' } },
      { id: 'privateRoom', name: { 'en-US': 'Shared Room', 'zh-CN': '合租' } },
      // { id: 'privateRoom', name: { 'en-US': 'Private Room', 'zh-CN': '可整套可分租' } },
      { id: 'masterBedroom', name: { 'en-US': 'Master Bedroom Only', 'zh-CN': '主卧出租' } },
      { id: 'secondaryBedroom', name: { 'en-US': 'Secondary bedroom', 'zh-CN': '次卧出租' } },
    ],
    elevator: [{ id: '1', name: { 'en-US': 'With Elevator', 'zh-CN': '有电梯' } }],
    floor: [
      { id: 'low', name: { 'en-US': 'Low', 'zh-CN': '低楼层' } },
      { id: 'mid', name: { 'en-US': 'Middle', 'zh-CN': '中楼层' } },
      { id: 'high', name: { 'en-US': 'High', 'zh-CN': '高楼层' } },
    ],
    insideFacility: [
      { id: '1', name: { 'en-US': 'aaa', 'zh-CN': 'aaa' } },
      { id: '2', name: { 'en-US': 'bbb', 'zh-CN': 'bbb' } },
    ],
    buildingFacility: [
      { id: '1', name: { 'en-US': 'aaa', 'zh-CN': 'aaa' } },
      { id: '2', name: { 'en-US': 'bbb', 'zh-CN': 'bbb' } },
    ],
    orientation: [
      { id: 'east', name: { 'en-US': 'East', 'zh-CN': '东' } },
      { id: 'south', name: { 'en-US': 'South', 'zh-CN': '南' } },
      { id: 'west', name: { 'en-US': 'West', 'zh-CN': '西' } },
      { id: 'north', name: { 'en-US': 'North', 'zh-CN': '北' } },
      { id: 'northWest', name: { 'en-US': 'NorthWest', 'zh-CN': '西北' } },
      { id: 'northEast', name: { 'en-US': 'NorthEast', 'zh-CN': '东北' } },
      { id: 'southWest', name: { 'en-US': 'SouthWest', 'zh-CN': '西南' } },
      { id: 'southEast', name: { 'en-US': 'SouthEast', 'zh-CN': '东南' } },
    ],
    decoration: [
      { id: 'simple', name: { 'en-US': 'Simple', 'zh-CN': '简单装修' } },
      { id: 'european', name: { 'en-US': 'European', 'zh-CN': '欧式极简' } },
      { id: 'fancy', name: { 'en-US': 'Fancy', 'zh-CN': '豪华装修' } },
    ],
    payPeriod: [
      { id: 'week', name: { 'en-US': 'Per Week', 'zh-CN': '周付' } },
      { id: 'month', name: { 'en-US': 'Per Month', 'zh-CN': '月付' } },
      { id: 'season', name: { 'en-US': 'Per Quarter', 'zh-CN': '季付' } },
      { id: 'year', name: { 'en-US': 'Per Year', 'zh-CN': '年付' } },
    ],
    other: [
      { id: 'privateBathroom', name: { 'en-US': 'Private Bathroom', 'zh-CN': '独立卫生间' } },
      { id: 'allowSmoking', name: { 'en-US': 'Allow Smoking', 'zh-CN': '可以抽烟' } },
      { id: 'allowCooking', name: { 'en-US': 'Allow Cooking', 'zh-CN': '可以做饭' } },
      { id: 'allowPet', name: { 'en-US': 'Allow Pets', 'zh-CN': '可养宠物' } },
      { id: 'male', name: { 'en-US': 'Allow Pets', 'zh-CN': '限男生' } },
      { id: 'female', name: { 'en-US': 'Allow Pets', 'zh-CN': '限女生' } },
      // { id: 'includeBill', name: { 'en-US': 'Include Bill', 'zh-CN': '包水电费' } },
      // { id: 'allowParty', name: { 'en-US': 'Allow Party', 'zh-CN': '允许聚会' } },
      // { id: 'noBondsman', name: { 'en-US': 'No Guarantor', 'zh-CN': '不需要担保人' } },
      // { id: 'noApplyFee', name: { 'en-US': 'No ApplyFee', 'zh-CN': '无申请费' } },
      // { id: 'isStudio', name: { 'en-US': 'Studio', 'zh-CN': '限studio' } },
    ],
  },
}

deepFreeze(CONFIG)

export default CONFIG
